import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../../utils/resources/fonts';
import { Colors } from '../../../../../utils/resources/colors';

export interface ForgotPasswordOTPMessageCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle(): object;
    getTitleCSSStyle(): object;
    getMobileNumberCSSStyle(): object;
    getRequestOTPButtonCSSStyle(): object;
    getSignUpRowDivCSSStyle():object;
    getSignUpCSSStyle():object;
    getDoUHaveAccountCSSStyle():object;
    getMessageCSSStyle(): object;
    getResendButtonCSSStyle(isRestricted:boolean):object;
    
}
export class ForgotPasswordOTPMessageCSSStyleImpl extends UIComponentCSSStyleImpl implements ForgotPasswordOTPMessageCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            borderRadius: "4px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "1px solid " + this.getResources().getColor(Colors.color_5),
            // width: "676px",
           
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginLeft: "10px",
            marginRight: "10px",
            marginTop: "150px",
            marginBottom: "150px",
        };
    }

    getInnerWrapperCSSStyle(): object 
    {
        return {
            // backgroundColor: this.getResources().getColor(Colors.color_5),
            flex: 0.68,
            justifyContent: "left",
            textAlign: "left",
            marginTop: "40px",
            marginBottom: "40px",
            width: '100%',
            padding: '0px 20px'
        };
    }

    getTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "left",
            // height: "40px",
            fontWeight: "bold",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_36),
            fontFamily:this.getResources().getFontFamily(),

            lineHeight: "40px"
        };
    }
    getResendButtonCSSStyle(isRestricted:boolean): object 
    {
        if(isRestricted)
        {
            return {
            display: "inline-block",
            textAlign: "left",
            paddingRight:'5px',
            height: "20px",
            letterSpacing: 0,
            fontWeight: 600,
            cursor:"no-drop",
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px"
        };
    }
    else{
        return {
            display: "inline-block",
            textAlign: "left",
            paddingRight:'5px',
            height: "20px",
            letterSpacing: 0,
            fontWeight: 600,
            cursor:"pointer",
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px"
        };
    }
    }

    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "40px",
        };
    }
    getRequestOTPButtonCSSStyle(): object 
    {
        return {
            marginTop: "50px",
            width:'180px'
        };
    }

    getMessageCSSStyle(): object {
        return {
            marginTop: "0px",
            display: "flex",
            textAlign: "left",
            width:"300px",
            // height: "40px",
            fontWeight: "bold",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_6),
            fontFamily:this.getResources().getFontFamily(),

            lineHeight: "20px"
        };
    }

    getDoUHaveAccountCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h5),
            color:this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
        };
    }

    getSignUpCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            paddingRight:'5px',
            letterSpacing: 0,
            fontWeight: 600,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            cursor:"pointer"
        };
    }
    getSignUpRowDivCSSStyle(): object {
        return {
            marginTop: "30px",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpmessage/forgotpasswordotpmessagecss.tsx